export const PROVIDERS_HEADER_TITLES = {
	ID: 'ID',
	STATUS: 'Статус',
	PROVIDER: 'Провайдер',
	CREATED_AT: 'Створено',
};
